export interface IQuery { }

export class ProjectPlanTemplatesPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.ProjectPlanTemplates.Queries.ProjectPlanTemplatesPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.ProjectPlanTemplates.Queries.ProjectPlanTemplatesPageQueryV1, TCh.Domain.Quest'
	}

}

